import { Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from 'app/services/spinner.service';
import { RegisterService } from 'app/services/user/register.service';

@Component({
  selector: 'ms-contract-sign-introduction',
  templateUrl: './contract-sign-introduction.component.html',
  styleUrls: ['./contract-sign-introduction.component.css']
})
export class ContractSignIntroductionComponent implements OnInit {
  registerId: any;
  personalData: any;
  companyData: any;

  constructor(
    private activatedRouter: ActivatedRoute, 
    private route: ActivatedRoute, 
    private router: Router, 
    private registerService: RegisterService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.start();
    this.registerId = this.activatedRouter.snapshot.paramMap.get("registerId");
    
    this.registerService.getCompletionResultForRegisterUser().subscribe(data => {
      /* console.log(data); */
      if (data) {
        if(!data.completedRegistration){
          if(!data.completedProfileDetail){
            this.router.navigate(['/registrazione/' + data.registerId + '/personalDetail']);
          } else if(!data.completedCompanyDetail){
            this.router.navigate(['/registrazione/' + data.registerId + '/companyDetail']);
          } 
        }
      }
      this.spinnerService.stop();
    });
  }

  goToContractSigningProcess(){
    this.spinnerService.start();
    this.router.navigate(['/registrazione/' + this.registerId + '/contract/sign']);
  }

  goToCompanyDetail(){
    this.spinnerService.start();
    this.router.navigate(['/registrazione/' + this.registerId + '/companyDetail']);
  }

  goToPersonalDetail(){
    this.spinnerService.start();
    this.router.navigate(['/registrazione/' + this.registerId + '/personalDetail']);
  }
}
